exports = module.exports = require("../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mw-user-collection__action-visibility-personalization-dialog-message--sub-text{margin:8px auto;font-size:14px;line-height:14px;width:100%;color:rgba(0,0,0,.26);text-align:center;width:75%}.mw-user-collection__action-visibility-personalization-dialog-filter-input{width:100%;margin:0}.mw-user-collection__action-visibility-personalization-dialog md-dialog-actions{border-top:1px solid rgba(0,0,0,.12)}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/@meltwater/gaf-ng-components-personalization/visibility_personalization_dialog.css
 ** module id = 153
 ** module chunks = 0 1
 **/